import { CalendarToday } from "@material-ui/icons";
import React, { useState, useEffect, useCallback, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import "./Style.css";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import ButtonForm from "../../../ReusableComponents/ButtonForm/ButtonForm";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { del } from "../../../constants/Images";
import moment from "moment";
import { getContext } from "../../../helpers/Context/Context";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import * as urls from "../../../helpers/API/APIEndPoints";
import {
  saveRecordMsg,
  updateRecordMsg,
  fileDeletionMsg,
} from "../../../helpers/Constants/Constants";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField, Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import {
  insertUpdateCalendarEvent,
  getCalendarEventDataById,
} from "../../../helpers/API/APIEndPoints";
import { APICall } from "../../../helpers/API/APICalls";
import { downloadBlob } from "../../../services/CommonService";
import { Modal } from "@material-ui/core";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import DeleteDialogueBox from "../../../ReusableComponents/DeleteDialogueBox/DeleteDialogueBox";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

function CalendarEventMasterEdit() {
  const [loading, setLoading] = useState(false);
  const [eventName, setEventName] = useState("");
  const [eventFromDate, setEventFromDate] = useState("");
  const [eventToDate, setEventTODate] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventVenue, setEventVenue] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [fileToBeDeleted, setFileToBeDeleted] = useState(null);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [files, setFiles] = useState([]);
  const [eventisActive, setEventIsActive] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [Id, setId] = useState(0);
  const [allowedFileTypes, setAllowedFileTypes] = useState("");
  let history = useHistory();
  let state_id = 0;
  const context = getContext();
  let formErrorObj = {};
  const inputFileRef = useRef();

  useEffect(() => {
    (async () => {
      // state_id = history?.location?.state?.id;
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id !== 0 || state_id != "0") {
        getCalendarEventByIdApiCall(state_id);
      }
    })();
  }, []);

  useEffect(() => {
    const allowedImagesFileTypesLS = getFromEncLocalStorage(
      "ImageFilesValidationExtension"
    );
    //const allowedVideoFileTypesLS = getFromEncLocalStorage("VideoFilesValidationExtension");
    if (allowedImagesFileTypesLS) {
      // || allowedVideoFileTypesLS) {
      setAllowedFileTypes(
        [
          ...allowedImagesFileTypesLS.split(","),
          //...allowedVideoFileTypesLS.split(',')
        ]
          .map((aift) => `.${aift}`)
          .join(",")
      );
    }
  }, []);

  const onFileChange = (e) => {
    if (
      [...e?.target?.files].filter(
        (f) => !(f.type.startsWith("image")
          // || f.type.startsWith("video")
        )
      ).length > 0
    ) {
      notify(1, "Only images are allowed!");
      return;
    }

    // #region check file extension with config value
    const allowedFileTypesArr = [...allowedFileTypes?.split(",")];
    if (allowedFileTypesArr) {
      let isExtensionAllowed = true;
      let filesToCheck = [...e?.target?.files];
      for (let index = 0; index < filesToCheck.length; index++) {
        const fileToCheck = filesToCheck[index];
        isExtensionAllowed = allowedFileTypesArr.some((ext) =>
          fileToCheck?.name?.endsWith(ext)
        );
        if (!isExtensionAllowed) break;
      }
      if (!isExtensionAllowed) {
        notify(1, `Only ${allowedFileTypesArr?.join(", ")} files are allowed!`);
        return;
      }
    }
    // #endregion

    //  setEventAttachment(e.target.files[0].name);
    let filesTmp = [...files];
    //  setEventAttachment(e.target.filesTmp[0].name)
    setFiles(filesTmp);
    for (let index = 0; index < e?.target?.files?.length; index++) {
      const file = e?.target?.files?.[index];
      if (file) {
        filesTmp.push({
          localUrl: URL.createObjectURL(file),
          blob: file,
          id: `img_${index}`,
          name: file.name,
          size: file.size,
          type: file.type,
        });
      }
    }
    setFiles(filesTmp);

    let errorProperties = { ...formErrors };
    errorProperties.attachments =
      filesTmp.length == 0 ? "attachments cannot be empty." : "";
    setFormErrors(errorProperties);
  };
  const saveImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    let resp = await CreateKnowledgeService.fileUpload(formData, "gallery");

    return resp;
  };
  const getCalendarEventByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getCalendarEventDataById, { id: id }, "POST");

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].Id) {
        let dataArr = data.data[0];
        let dataObj = dataArr[0];
        setId(data.data[0][0].Id);
        setEventName(data.data[0][0].activity_title);
        setEventFromDate(data.data[0][0].FromDT);
        setEventTODate(data.data[0][0].ToDT);
        setEventDescription(data.data[0][0].activity_desc);
        setEventLocation(data.data[0][0].Location);
        setEventVenue(data.data[0][0].Venue);
        setEventIsActive(data.data[0][0].IsActive);

        let filesTmp = [];
        setFiles(filesTmp);
        for (let index = 0; index < dataArr?.length; index++) {
          dataObj = dataArr?.[index];
          if (dataObj) {
            const fullResImgUrl = await downloadBlob(dataObj.docUrl);

            const azureFileName = dataObj?.docUrl
              ? new URL(dataObj?.docUrl)?.pathname?.split("/")?.pop()
              : null;

            filesTmp.push({
              localUrl: null,
              blob: null,
              id: dataObj.docid || `img_${index}`,
              name: dataObj.DocName,
              size: null,
              type: dataObj.docExtension,
              globalUrl: fullResImgUrl,
              azureFileName: azureFileName,
              exists: true,
            });
          }
        }
        setFiles(filesTmp);

        setEditModeIsActive(false);
        setEditModeDisableButton(false);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };
  const handleFilterChange = async (e, name) => {
    if (name === "fromDate") {
      setEventFromDate(e);
      await setFormErrors({
        ...formErrors,
        ["EventFromDate_isEmpty"]: "",
      });
      if (e == null || e == undefined) {
        await setFormErrors({
          ...formErrors,
          ["EventFromDate_isEmpty"]: "From Date cannot be empty",
        });
      }
    }

    if (name === "toDate") {
      setEventTODate(e);
      await setFormErrors({
        ...formErrors,
        ["EventToDate_isEmpty"]: "",
      });
      if (e == null || e == undefined) {
        await setFormErrors({
          ...formErrors,
          ["EventToDate_isEmpty"]: "To Date cannot be empty",
        });
      }
    }

    if (name === "name") {
      let n = e.target.value;
      await setEventName(n);
      var validString = /^[a-zA-Z0-9" "]+$/.test(n);
      await setFormErrors({
        ...formErrors,
        ["EventName_isEmpty"]: "",
      });

      if (n == "" || n == null || n == undefined) {
        await setFormErrors({
          ...formErrors,
          ["EventName_isEmpty"]: "Event Name cannot be empty",
        });
      } else {
        if (validString == false) {
          // await setFormErrors({
          //   ...formErrors,
          //   ["EventName_isEmpty"]: "Special Characters are not allowed",
          // });
        }
      }
    }
    if (name === "location") {
      let loc = e.target.value;
      await setEventLocation(loc);
      var validString = /^[a-zA-Z0-9" "]+$/.test(loc);
      await setFormErrors({
        ...formErrors,
        ["Location_isEmpty"]: "",
      });
      if (loc == "" || loc == null || loc == undefined) {
        await setFormErrors({
          ...formErrors,
          ["Location_isEmpty"]: "Location cannot be empty",
        });
      } else {
        if (validString == false) {
          // await setFormErrors({
          //   ...formErrors,
          //   ["Location_isEmpty"]: "Special Characters are not allowed",
          // });
        }
      }
    }
    if (name === "Venue") {
      let venue = e.target.value;
      await setEventVenue(venue);
      var validString = /^[a-zA-Z0-9" "]+$/.test(venue);
      await setFormErrors({
        ...formErrors,
        ["Venue_isEmpty"]: "",
      });
      if (venue == "" || venue == null || venue == undefined) {
        await setFormErrors({
          ...formErrors,
          ["Venue_isEmpty"]: "Venue cannot be empty",
        });
      } else {
        if (validString == false) {
          // await setFormErrors({
          //   ...formErrors,
          //   ["Venue_isEmpty"]: "Special Characters are not allowed",
          // });
        }
      }
    }
    if (name === "description") {
      let desc = e.target.value;
      await setEventDescription(desc);
      var validString = /^[a-zA-Z0-9-,.( )" "]+$/.test(desc);
      await setFormErrors({
        ...formErrors,
        ["Description_isEmpty"]: "",
      });
      if (desc == "" || desc == null || desc == undefined) {
        await setFormErrors({
          ...formErrors,
          ["Description_isEmpty"]: "Description cannot be empty",
        });
      } else if (validString == false) {
        // await setFormErrors({
        //   ...formErrors,
        //   ["Description_isEmpty"]: "Special Characters are not allowed",
        // });
      } else if (desc.length > 500) {
        await setFormErrors({
          ...formErrors,
          ["Description_isEmpty"]: "You cannot enter more than 500 characters",
        });
      }
    }
    if (name === "attachments") {
      //   inputFileRef.current.click();
      handleBtnClick(e);
      setFormErrors({
        ...formErrors,
        ["Attachments_isEmpty"]: "",
      });
      if (e.length == 0) {
        setFormErrors({
          ...formErrors,
          ["Attachments_isEmpty"]: "Attachments cannot be empty",
        });
      }
    }
  };
  const handleBtnClick = (e) => {
    inputFileRef.current.click();
  };
  const deleteImage = async (file) => {
    setLoading(true);
    try {
      let filesTmp = [...files];
      filesTmp = filesTmp.filter((f) => f.id !== file.id);
      setShowDeleteConfirmationModal(false);

      if (file?.globalUrl) {
        const res = await APICall(urls.deleteDocument, {
          ids: `${file.id}`,
          name: file.azureFileName,
        });

        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            notify(0, fileDeletionMsg);
          }
        } else {
          notify(1, res.message);
        }
      }

      URL.revokeObjectURL(file.localUrl);

      setFiles(filesTmp);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const checkValidation = async () => {
    var objError = {};
    await setFormErrors({});
    if (eventName == undefined || eventName == null || eventName == "") {
      objError["EventName_isEmpty"] = "Event Name  cannot be empty";
    }
    if (
      eventLocation == undefined ||
      eventLocation == null ||
      eventLocation == ""
    ) {
      objError["Location_isEmpty"] = " Location cannot be empty";
    }
    if (eventVenue == undefined || eventVenue == null || eventVenue == "") {
      objError["Venue_isEmpty"] = " Venue cannot be empty";
    }
    if (
      eventDescription == undefined ||
      eventDescription == null ||
      eventDescription == ""
    ) {
      objError["Description_isEmpty"] = " Description cannot be empty";
    } else if (eventDescription.replace(/\s+/g, " ").trim().length >= 500) {
      objError["Description_isEmpty"] =
        "Description Is Longer Than The 500 Character";
    }
    if (
      eventFromDate == undefined ||
      eventFromDate == null ||
      eventFromDate == ""
    ) {
      objError["EventFromDate_isEmpty"] = " From Date  cannot be empty";
    }
    if (eventToDate == undefined || eventToDate == null || eventToDate == "") {
      objError["EventToDate_isEmpty"] = " To Date  cannot be empty";
    }
    if (eventFromDate && eventToDate) {
      let eventFromDateObj = moment(eventFromDate);
      let eventToDateObj = moment(eventToDate);

      if (eventFromDateObj.isValid() && eventToDateObj.isValid()) {
        if (
          eventFromDateObj.isAfter(eventToDateObj) ||
          eventToDateObj.isBefore(eventFromDateObj)
        ) {
          objError["EventFromDate_isEmpty"] =
            " From Date cannot be after To Date";
          objError["EventToDate_isEmpty"] =
            " To Date cannot be before From Date";
        }
      }
    }
    // if (files.length == 0) {
    //   objError["Attachments_isEmpty"] = "Attachments cannot be empty";
    // }
    formErrorObj = objError;
    await setFormErrors(objError);
    return objError;
  };

  const onSubmit = async (action) => {
    if (action == "Submit") {
      let newFormErrors = await checkValidation();
      const isEmpty = await Object.values(newFormErrors).every(
        (x) => x === null || x === "" || x == undefined
      );
      setLoading(true);
      if (isEmpty) {
        let filesTmp = [];
        if (files?.length > 0) {
          filesTmp = [...files];
          for (let index = 0; index < filesTmp?.length; index++) {
            const file = filesTmp?.[index];
            if (!file?.globalUrl) {
              let resp = await saveImage(file.blob);
              let imgUrl = resp?.result?.[0];
              if (imgUrl) {
                file.globalUrl = imgUrl;
              }
            }
          }
          setFiles(filesTmp);

          if (filesTmp.filter((f) => !f?.globalUrl).length > 0) {
            //some images failed to upload.
            notify(
              1,
              "Some of the images have been failed to upload. Please try again later."
            );
            return;
          }
        }
        let startdate = moment(eventFromDate).format("yyyy-MM-DD");
        let starttime = moment(eventFromDate).format("h:mm:A");
        let enddate = moment(eventToDate).format("yyyy-MM-DD");
        let endtime = moment(eventToDate).format("h:mm:A");
        //console.log(context.employeenumber)
        // console.log(startdate, starttime)
        let creator = getFromEncLocalStorage("userId");
        let reqBody = {
          Id: Id,
          mode: Id ? "edit" : "create",
          Title: eventName,
          Description: eventDescription,
          StartDate: startdate,
          StartTime: starttime,
          EndDate: enddate,
          EndTime: endtime,
          Location: eventLocation,
          Venue: eventVenue,
          attachments: filesTmp,
          isActive: eventisActive,
          createdBy: creator,
        };
        console.log(reqBody);

        const res = await APICall(insertUpdateCalendarEvent, reqBody, "POST");
        //  console.log(eventFromDate, eventToDate)
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
              setLoading(false);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
              setLoading(false);
            }
            history.push({ pathname: "/calendarEvent-master" });
          }
          setLoading(false);
        } else {
          notify(
            1,
            typeof res?.message === "string"
              ? res?.message
              : res?.message?.message
          );
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/calendarEvent-master" });
    }
    setLoading(false);
  };

  const resetFunction = () => {
    setFormErrors({});
    setEventName("");
    setEventDescription("");
    setEventFromDate("");
    setEventTODate("");
    setEventLocation("");
    setEventVenue("");

    formErrorObj = {};
  };
  return (
    <>
      <Main active={"calendarEvent_master"} removeContainer={true}>
        <Loadspinner filename="CalendarEventMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4 ">
                <h4>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8  headerText">Calendar Event</div>
              </div>
              <div className="mx-3">
                <div className="col-lg-12 col-md-12 mt-3">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Event Name<sup>*</sup>
                        </label> */}
                        <FormLabel value="Event Name" />
                        <sup>*</sup>
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={eventName}
                          onChange={(e) => handleFilterChange(e, "name")}
                          style={{ marginTop: "5px" }}
                        />
                        {/* <p style={{ color: "red", fontWeight: "bold" }}>
                          {formErrors["EventName_isEmpty"]}
                        </p> */}
                        <ErrorLabel value={formErrors["EventName_isEmpty"]} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6  txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Event From Date & Time<sup>*</sup>
                        </label> */}
                        <FormLabel value="Event from date & time" />
                        <sup>*</sup>
                        <br></br>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          {/* <DatePicker
                        label="From date"
                        style={{ marginTop: "5px" }}
                        value={eventFromDate}
                        onChange={(e) => handleFilterChange(e, "fromDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      /> */}
                          <DateTimePicker
                            label=" "
                            style={{ marginTop: "5px" }}
                            value={eventFromDate}
                            onChange={(e) => handleFilterChange(e, "fromDate")}
                            inputFormat="dd/MM/yyyy h:mm a"
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  backgroundColor: "white",
                                  display: "flex",
                                }}
                                size="small"
                                {...params}
                                error={false}
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                              />
                            )}
                          />
                          {/* <p style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors["EventFromDate_isEmpty"]}
                          </p> */}
                          <ErrorLabel
                            value={formErrors["EventFromDate_isEmpty"]}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Event To Date & Time<sup>*</sup>
                        </label> */}
                        <FormLabel value="Event to date & time" />
                        <sup>*</sup>
                        <br></br>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          {/* <DatePicker
                        label="To date"
                        value={eventToDate}
                        onChange={(e) => handleFilterChange(e, "toDate")}
                      //  inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      /> */}
                          <DateTimePicker
                            label=" "
                            style={{ marginTop: "5px" }}
                            value={eventToDate}
                            onChange={(e) => handleFilterChange(e, "toDate")}
                            inputFormat="dd/MM/yyyy h:mm a"
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  backgroundColor: "white",
                                  display: "flex",
                                }}
                                size="small"
                                {...params}
                                error={false}
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                              />
                            )}
                          />
                          {/* <p style={{ color: "red" , fontWeight: "bold"}}>
                            {formErrors["EventToDate_isEmpty"]}
                          </p> */}
                          <ErrorLabel
                            value={formErrors["EventToDate_isEmpty"]}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Location<sup>*</sup>
                        </label> */}
                        <FormLabel value="Location" />
                        <sup>*</sup>
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={eventLocation}
                          onChange={(e) => handleFilterChange(e, "location")}
                        />
                        {/* <p style={{ color: "red" ,  fontWeight: "bold"}}>
                          {formErrors["Location_isEmpty"]}
                        </p> */}
                        <ErrorLabel value={formErrors["Location_isEmpty"]} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Event Venue<sup>*</sup>
                        </label> */}
                        <FormLabel value="Venue" />
                        <sup>*</sup>
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={eventVenue}
                          style={{ marginTop: "5px" }}
                          onChange={(e) => handleFilterChange(e, "Venue")}
                        />
                        {/* <p style={{ color: "red", fontWeight: "bold" }}>{formErrors["Venue_isEmpty"]}</p> */}
                        <ErrorLabel value={formErrors["Venue_isEmpty"]} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Event Description<sup>*</sup>
                        </label> */}
                        <FormLabel value="Description" />
                        <sup>*</sup>
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={true}
                          value={eventDescription}
                          style={{ marginTop: "5px" }}
                          maxLength={500}
                          onChange={(e) => handleFilterChange(e, "description")}
                        />
                        {/* <p style={{ color: "red" , fontWeight: "bold"}}>
                          {formErrors["Description_isEmpty"]}
                        </p> */}
                        <ErrorLabel value={formErrors["Description_isEmpty"]} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="labelstyle">
                          Attach images/videos<sup>*</sup>
                        </label> */}
                        <FormLabel value="Attach images" />
                        {/* <sup>*</sup> */}
                        <InputGroup className="mb-3">
                          <InputForm
                            className="form-control form-control-sm fileInputStyle"
                            placeholder={files.length + " images selected"}
                            isDisabled={false}
                            textArea={false}
                            onClick={(e) =>
                              handleFilterChange(e, "attachments")
                            }
                            readOnly
                          />
                          <ButtonForm
                            variant="secondary"
                            id="button-addon2"
                            value="Browse"
                            onClick={(e) =>
                              handleFilterChange(e, "attachments")
                            }
                          />
                        </InputGroup>
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="btn_event_gallery_master_file_input"
                          ref={inputFileRef}
                          onChange={onFileChange}
                          onClick={(event) => {
                            event.target.value = null;
                          }}
                          multiple
                          accept={allowedFileTypes}
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                        {/* <p style={{ color: "red", fontWeight: "bold" }}>
                          {formErrors["Attachments_isEmpty"]}
                        </p> */}
                        {/* <ErrorLabel value={formErrors["Attachments_isEmpty"]} /> */}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 txt-box">
                      <div className="form-group">
                        {/* <label className="col-form-label labelstyle">Active Status<sup>*</sup></label> */}
                        <FormLabel value="Active Status" />
                        {/* <sup>*</sup> */}
                        <div className="custom-checkbox">
                          <input
                            style={{ marginLeft: "5px" }}
                            id="isActive"
                            type="checkbox"
                            onChange={(e) => setEventIsActive(e.target.checked)}
                            name="isActive"
                            checked={eventisActive}
                            className="isActive"
                            disabled={editModeIsActive ? true : false}
                            autoComplete={CommonConstants.autoCompleteInput}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {files?.map((file, fIdx) => {
                    return (
                      <Card
                        key={`img${fIdx}`}
                        className="col-lg-2 col-sm-2 col-xs-2 imgCard"
                      >
                        {/* {file.type.startsWith("video") ? (
                          <video
                            src={file?.localUrl || file?.globalUrl}
                            className="gridImage"
                          />
                        ) : ( */}
                        <Card.Img
                          variant="top"
                          src={file?.localUrl || file?.globalUrl}
                          className="gridImage"
                        />
                        {/* )} */}
                        <Card.Body className="imgCardBody">
                          <div className="row my-1">
                            <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
                              <Card.Text>{file?.name}</Card.Text>
                            </div>
                            <div className="col-lg-2 col-sm-2 col-xs-2">
                              <Button variant="outline-light" size="sm">
                                <Image
                                  src={del}
                                  className="delBtn"
                                  onClick={() => {
                                    setFileToBeDeleted(file);
                                    setShowDeleteConfirmationModal(true);
                                  }}
                                />
                              </Button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton onClick={() => onSubmit("Submit")} />
                      {editModeDisableButton && (
                        <ResetButton onClick={() => onSubmit("Reset")} />
                      )}
                      <CancelButton onClick={() => onSubmit("Cancel")} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal
          open={showDeleteConfirmationModal}
          onClose={() => setShowDeleteConfirmationModal(false)}
          className="modal-dialog modal-dialog-centered"
        >
          <div className="modal-content logout-modal">
            <div className="modal-body">
              Are you sure you want to delete this image?
            </div>
            <div className="display-row justify-space-evenly">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => {
                  setFileToBeDeleted(null);
                  setShowDeleteConfirmationModal(false);
                }}
              >
                Cancel
              </button>
            
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => deleteImage(fileToBeDeleted)}
              >
                Delete
              </button>
           
            </div>
          </div>
        </Modal> */}
        <DeleteDialogueBox
          open={showDeleteConfirmationModal}
          close={() => setShowDeleteConfirmationModal(false)}
          cancel={() => {
            setFileToBeDeleted(null);
            setShowDeleteConfirmationModal(false);
          }}
          deleteImage={() => deleteImage(fileToBeDeleted)}
        />
      </Main>
    </>
  );
}

export default CalendarEventMasterEdit;
